/** InsCoder WANG.J 2026-02-01 B + M2 Ecocredits Benefits Section - Terms Popup **/
(function() {
  'use strict';

  /**
   * M2 Benefits Section - Terms & Conditions Popup Controller
   */
  function initM2BenefitsPopup() {
   document.querySelectorAll('.cust-m2-benefits').forEach(function(section) {
        if (section.dataset.m2BenefitsPopupBound === 'true') return;
        section.dataset.m2BenefitsPopupBound = 'true';

        const termsLinks = section.querySelectorAll('.cust-m2-benefits__terms-link');
        const popupOverlay = section.querySelector('.cust-m2-benefits__popup-overlay');
        const popup = section.querySelector('.cust-m2-benefits__popup');
        const closeBtn = section.querySelector('.cust-m2-benefits__popup-close');

        if (!termsLinks.length || !popup || !popupOverlay) {
          return;
        }

        /**
         * Open the popup
         */
        function openPopup() {
          popupOverlay.classList.add('is-active');
          popup.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }

        /**
         * Close the popup
         */
        function closePopup() {
          popupOverlay.classList.remove('is-active');
          popup.classList.remove('is-active');
          document.body.style.overflow = '';
        }

        // Bind click events to terms links
        termsLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            openPopup();
          });
        });

        // Close button click
        if (closeBtn) {
          closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            closePopup();
          });
        }

        // Close on overlay click
        popupOverlay.addEventListener('click', function(e) {
          if (e.target === popupOverlay) {
            closePopup();
          }
        });

        // Close on ESC key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && popup.classList.contains('is-active')) {
            closePopup();
          }
        });
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initM2BenefitsPopup);
  } else {
    initM2BenefitsPopup();
  }
})();
/** InsCoder WANG.J 2026-02-01 E + M2 Ecocredits Benefits Section - Terms Popup **/
